<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-12">
            <h1>
              Routing Area
              <router-link
                :to="{ name: 'RoutingAreaAdd' }"
                class="btn ml-auto"
                v-if="actionCreate"
              >
                <i class="icon-plus"></i> New
              </router-link>
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Routing Area</li>
            </ol>
          </div>
        </div>
      </div>
      <!-- /.container-fluid -->
    </section>

    <section class="content" v-if="has_permission === true">
      <div class="container-fluid">
        <div class="card">
          <div
            class="card-header py-3"
            v-if="!_.isEmpty(list.data) && is_loading == false"
          >
            <div class="btn-toolbar pull-right"></div>

            <!-- <div class="card-tools">
              <button class="btn btn-outline" @click="exportFile()">
                <i class="icon-download"></i> Export
              </button>
            </div> -->
          </div>
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>

          <div class="card-body">
            <div v-if="!_.isEmpty(list.data) && is_loading == false">
              <h6 v-if="organizationId == 1">Total Item: {{ list.total }}</h6>

              <div class="table-responsive-md">
                <table class="table">
                  <thead>
                    <tr>
                      <th v-if="organizationId == '1'">Audra</th>
                      <th>Name</th>
                      <th>ID</th>
                      <th class="text-right">Action</th>
                    </tr>
                  </thead>
                  <tbody class="list">
                    <tr v-for="(val, index) in list.data">
                      <td v-if="organizationId == 1">
                        {{ val.device_name }}
                      </td>
                      <td>{{ val.area_name }}</td>
                      <td>{{ val.area_id }}</td>
                      <td class="text-right">
                        <router-link
                          v-if="actionEdit == true"
                          :to="{
                            name: 'RoutingAreaEdit',
                            params: { id: val.id }
                          }"
                          class="btn btn-edit"
                        >
                          <i class="icon-edit"></i>
                        </router-link>
                        <a
                          v-if="actionDelete == true"
                          class="btn btn-trash"
                          href="javascript:void(0)"
                          @click="deleteObject(val.id, val.accountId, index)"
                          ><i class="icon-trash"></i
                        ></a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="mt-2 text-right d-block d-sm-none">
                Swipe <i class="icon-swipe"></i>
              </div>
            </div>
            <div class="p-4" v-if="_.isEmpty(list.data) && is_loading == false">
              <div class="no-data">
                <img src="/assets/images/no-data.svg" alt="" />
                <h3>No data found!</h3>
              </div>
            </div>
          </div>

          <div :class="{ 'card-footer': list.total > list.per_page }">
            <vue-pagination
              :pagination="list"
              v-if="list.total > list.per_page"
              @paginate="reload()"
            ></vue-pagination>
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>

<script>
import LocalStorage from '@/services/localStorage'
import VuePagination from '@/components/partials/PaginationComponent'
import SortIcons from '@/components/utils/SortIcons'
import axios from 'axios'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import { CommonAPI, PermissionChecker } from '@/services/api'
import { mapGetters, mapActions } from 'vuex'
import { Notification } from 'element-ui'
const fileDownload = require('js-file-download')

export default {
  name: 'RoutingArea',
  metaInfo: {
    title: 'Routing Area | Dotlines'
  },
  components: {
    VuePagination
  },
  data: () => ({
    organizationId: LocalStorage.get('organizationId'),
    userEmail: LocalStorage.get('userEmail'),
    list: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1
    },
    actionCreate: true,
    actionView: true,
    actionEdit: true,
    actionDelete: true,
    api_url: '',
    showFilter: false,
    filter: {},
    dateRange: '',
    pre: [],
    is_loading: false,
    empty: false,
    empty_message: '',
    custom_permission_data: [],
    has_permission: true
  }),

  mounted: function () {
    if (this.isMobile()) {
      window
        .$(document)
        .find('.push-menu-class')
        .trigger('click')
    }
    this.api_url = '/routing_areas'
    this.initialize()
    this.$root.$on('sort-data', () => {
      this.$root.$emit('show-icon')
      this.reload()
    })
  },
  computed: {
    ...mapGetters(['profile'])
  },
  methods: {
    async initialize () {
      this.is_loading = true
      if (_.isEmpty(this.profile)) {
        await CommonAPI.getProfile().then(profile_info => {
          this.user_detail = profile_info
        })
      } else {
        this.user_detail = this.profile
      }

      // await CommonAPI.getCustomPermission(
      //   '/get-custom-permission-infos?path=api/routing_areas'
      // ).then(response => {
      //   if (response.status == 200) {
      //     this.custom_permission_data = response.data
      //   }
      // })

      // if (!_.isEmpty(this.custom_permission_data)) {
      //   this.actionCreate = await PermissionChecker.checkCreateButtonPermission(
      //     this.custom_permission_data.action_permission,
      //     this.custom_permission_data['create_id_condition'],
      //     this.user_detail,
      //     this.custom_permission_data.enableAdministratorPermissionByDefault
      //   )
      //   this.actionCreate = true
      // }

      await this.getList()
        .then(response => {
          this.list = response.data
        })
        .catch(error => {
          this.empty = true
          if (error.response.status === 403) {
            this.has_permission = false
          }
        })
      this.is_loading = false
    },

    reload: function () {
      this.getList()
        .then(response => {
          this.list = response.data
        })
        .catch(error => {
          this.empty = true
          if (error.response.status === 403) {
            this.has_permission = false
          }
        })
    },
    getList: function () {
      return new Promise((resolve, reject) => {
        let params = { page: this.list.current_page }
        params = {
          ...this.filter,
          userAccountId: LocalStorage.get('accountId'),
          ...this.$route.query,
          ...params
        }
        axios
          .get(this.api_url, {
            params: params
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
            // console.log("error", error.response.data);
          })
          .finally(() => {
            // _this.is_loading = false;
          })
      })
    },
    checkEditPermission: function (data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkEditButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data['edit_id_condition'],
          this.custom_permission_data['edit_refid_condition'],
          this.custom_permission_data['edit_custom_condition'],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        )
      } else {
        return false
      }
    },
    checkDeletePermission: function (data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkDeleteButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data['delete_id_condition'],
          this.custom_permission_data['delete_refid_condition'],
          this.custom_permission_data['delete_custom_condition'],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        )
      } else {
        return false
      }
    },

    deleteObject: function (id, accountId, index) {
      const _this = this
      const delete_api_url = '/routing_areas/' + id

      _this.$swal
        .fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        })
        .then(result => {
          if (result.isConfirmed) {
            _this.is_loading = true
            axios
              .delete(delete_api_url, {
                params: {
                  accountId: accountId
                }
              })
              .then(response => {
                _this.list.data.splice(index, 1)
                _this.$toaster.success(response.data.message)
                _this.is_loading = false
              })
              .catch(error => {

                _this.is_loading = false
                console.log(error)
                if (error.response.data.errors) {
                  _this.$swal.fire('Failed!', error.response.data.errors.message, 'error')
                } else {
                  _this.$swal.fire('Failed!', 'failed to delete.', 'error')
                }
              })
              .finally(() => {
                _this.is_loading = false
              })
          }
        })
    },
    exportFile: function () {
      this.is_loading = true
      axios
        .get('/routing-areas-export', {
          params: { userAccountId: LocalStorage.get('accountId') },
          responseType: 'blob'
        })
        .then(response => {
          fileDownload(response.data, 'routing_areas.xlsx')
        })
        .catch(error => {
          console.log('error ' + error)
        })
        .finally(() => {
          this.is_loading = false
          Notification.success({
            title: 'Export Completed',
            message: 'Export operation completed successfully',
            type: 'success'
          })
        })
    }
  }
}
</script>
